import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import Tab from "@mui/material/Tab";
import Tabs from "@mui/material/Tabs";
import Typography from "@mui/material/Typography";
import React, { useState } from "react";
import DictionaryStats from "./DictionaryStats";
import PuzzleStats from "./PuzzleStats";

const puzzleTypes = [
    { label: "Draft", value: null },
    { label: "Crossword", value: "CROSSWORD" },
    { label: "Hidden Message", value: "HIDDEN_MESSAGE" },
    { label: "Word Search", value: "WORD_SEARCH" },
    { label: "Dictionary", value: "DICTIONARY" }
];

export default function AdminStatisticsMain() {
    const [activeTab, setActiveTab] = useState(0);

    const handleTabChange = (_event, newValue) => {
        setActiveTab(newValue);
    };

    return (
        <Grid container spacing={2} sx={{ p: 2, width: '100%', maxWidth: '100%', boxSizing: 'border-box' }}>
            <Grid size={{ xs: 12 }} sx={{ width: '100%', maxWidth: '100%' }}>
                <Typography variant="h4" gutterBottom>
                    Statistics
                </Typography>
                <Typography variant="body1" color="text.secondary">
                    Puzzle statistics by genre and status
                </Typography>
            </Grid>

            <Grid size={{ xs: 12 }} sx={{ width: '100%' }}>
                <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                    <Tabs value={activeTab} onChange={handleTabChange} aria-label="puzzle type tabs">
                        {puzzleTypes.map((type, index) => (
                            <Tab key={type.value || `tab-${index}`} label={type.label} />
                        ))}
                    </Tabs>
                </Box>
            </Grid>

            <Grid size={{ xs: 12 }} sx={{ width: '100%' }}>
                {puzzleTypes[activeTab].value === "DICTIONARY" ? (
                    <DictionaryStats />
                ) : (
                    <PuzzleStats puzzleType={puzzleTypes[activeTab].value} />
                )}
            </Grid>
        </Grid>
    );
}
